import React from 'react';
import Link from 'gatsby-link';

import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Spacing from '@marvelapp/marvel-ui/spacing';
import Button from '@marvelapp/marvel-ui/button';
import Heading from '@marvelapp/marvel-ui/heading';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import MarvelLink from '@marvelapp/marvel-ui/link';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Align from '@marvelapp/marvel-ui/align';

import IntegrationsCta from 'marketing-website/components/modules/IntegrationsCta';
import Whitespace from 'marketing-website/components/commons/Whitespace';
import Image from 'marketing-website/components/modules/Image';
import Page from 'marketing-website/components/modules/Page';
import assets from 'marketing-website/configs/pages/android-app-builder/assets';

import Images from './images.js';
import Export from './export.js';
import Integrate from './integrate.js';
import Questions from './questions.js';
import Share from './share.js';

export default function AndroidAppBuilder() {
  return (
    <Page
      title="Android App Builder | Marvel"
      meta={[
        {
          name: 'description',
          content:
            'Make and build Android apps from images, sketches and designs. No coding required. Just click download and we’ll package it up using our Android App Maker.',
        },
        {
          name: 'keywords',
          content:
            'android app builder, app maker, apk maker, prototype to apk, build apps',
        },
      ]}
      header
      footer
    >
      <PageWrap size="l">
        <Whitespace size="s" sizeS="l" sizeM="xl" />
        <Align type="center">
          <Spacing size="s" type="padding" position="bottom">
            <Image {...assets.illustration} />
          </Spacing>
          <MaxWidth value={720}>
            <Heading tag="h1" weight="semibold" size="mega">
              Turn your prototypes into Android Apps
            </Heading>
          </MaxWidth>
          <Spacing size="s" type="padding" position="topBottom">
            <MaxWidth value={720}>
              <Paragraph size="xxxl" color="slate">
                Upgrade to Marvel Pro and export prototypes into offline Android
                apps (.apk) with no coding involved. Requires Lollipop 5.0+,
                available on Marvel Pro, Company, and Enterprise plans.{' '}
                <Link to="/pricing">
                  <MarvelLink type="blue">Click here</MarvelLink>
                </Link>{' '}
                for more info.
              </Paragraph>
            </MaxWidth>
          </Spacing>
          <Spacing size="s" type="padding" position="top">
            <Spacing size="l" type="padding" position="bottom">
              <Link to="/signup">
                <Button size="large" shape="rounded" hover="blue">
                  Start prototyping
                </Button>
              </Link>
            </Spacing>
          </Spacing>
          <Images />
          <Export />
          <Share />
          <Integrate />
          <Questions />
        </Align>
      </PageWrap>

      <IntegrationsCta />
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/android-app-builder/index.js